/* Rippl page base (14 Oct 2026): press feedback on pointer-down (scale .97 in rpg-base.css) and copy buttons.
   Source: theme-build/page-base/assets/rpg-base.js. Defines itself once, so any number of sections may load it. */
(function () {
  'use strict';
  if (window.__rpgBase) return;
  window.__rpgBase = true;

  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('.rpg .rpg-btn, .rpg .rpg-chip, .rpg [data-rpg-press]');
    if (!b) return;
    b.classList.add('rpg-pr');
    var up = function () {
      b.classList.remove('rpg-pr');
      removeEventListener('pointerup', up); removeEventListener('pointercancel', up);
    };
    addEventListener('pointerup', up); addEventListener('pointercancel', up);
  });

  /* Copy buttons: <button data-rpg-copy="text">Copy</button>. The label says Copied for a moment, and a live region says it too. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.rpg [data-rpg-copy]');
    if (!b) return;
    var text = b.getAttribute('data-rpg-copy'), label = b.getAttribute('data-label') || b.textContent;
    b.setAttribute('data-label', label);
    var done = function (ok) {
      b.textContent = ok ? 'Copied' : 'Press and hold to copy';
      var live = document.getElementById('rpg-live');
      if (live) live.textContent = ok ? text + ' copied' : '';
      clearTimeout(b.__t); b.__t = setTimeout(function () { b.textContent = label; }, 1800);
    };
    try {
      navigator.clipboard.writeText(text).then(function () { done(true); }, function () { done(fallback(text)); });
    } catch (x) { done(fallback(text)); }
  });
  function fallback(text) {
    try {
      var t = document.createElement('textarea');
      t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      var ok = document.execCommand('copy'); t.remove(); return ok;
    } catch (x) { return false; }
  }
})();
